import type { I18n } from '@lingui/core'
import type { VFC } from 'react'

import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import TransWithHtml from 'views/components/utils/TransWithHtml'

import type { ProductAttributes, VariantAttributesExcluded } from './../index'

interface AttributePickerModalInfoButtonProps {
  variantAttribute: ProductAttributes | VariantAttributesExcluded
  i18n: I18n
  iconSize?: string
}

const AttributePickerModalAndInfoButton: VFC<
  AttributePickerModalInfoButtonProps
> = ({ variantAttribute, i18n, iconSize = 'default' }) => {
  const getInfoModal = (
    modalHeadlineText: string,
    modalDescriptionTranslationId: string
  ) => {
    return (
      <Modal id={variantAttribute.code} size="medium" title={modalHeadlineText}>
        <TransWithHtml
          id={modalDescriptionTranslationId}
          element="div"
          className="u-margin-large--bottom"
        />
      </Modal>
    )
  }
  const getVariantInfoModal = () => {
    switch (variantAttribute.code) {
      case 'sphere_power':
        return getInfoModal(
          i18n._('variantAttributes.contactLens.dioptre.info.headline'),
          'variantAttributes.contactLens.dioptre.info.massage'
        )
      case 'base_curve':
        return getInfoModal(
          i18n._('variantAttributes.contactLens.baseCurve.info.headline'),
          'variantAttributes.contactLens.baseCurve.info.massage'
        )
      case 'addition':
        return getInfoModal(
          i18n._('variantAttributes.contactLens.addition.info.headline'),
          'variantAttributes.contactLens.addition.info.massage'
        )
      case 'axis':
        return getInfoModal(
          i18n._('variantAttributes.contactLens.axis.info.headline'),
          'variantAttributes.contactLens.axis.info.massage'
        )
      case 'cylinder':
        return getInfoModal(
          i18n._('variantAttributes.contactLens.cylinder.info.headline'),
          'variantAttributes.contactLens.cylinder.info.massage'
        )
      case 'diameter':
        return getInfoModal(
          i18n._('variantAttributes.contactLens.diameter.info.headline'),
          'variantAttributes.contactLens.diameter.info.massage'
        )
      default:
        return null
    }
  }

  return (
    <>
      <ModalShowButton
        component={ButtonTransparent}
        name={variantAttribute.label}
        onClick={null}
        modalId={variantAttribute.code}
        inline
        small
        title={variantAttribute.label}
      >
        <IconCircleInfo size={iconSize} className="u-color--blue" />
      </ModalShowButton>
      {getVariantInfoModal()}
    </>
  )
}

export default AttributePickerModalAndInfoButton
